import React from "react";
import Auth from "src/auth";
import { useHistory } from "react-router-dom";
import { CButton } from "@coreui/react";

const LotListViewTransferButton = (props) => {
  const { authenticated } = Auth();
  let history = useHistory();
  return (
    <>
      {/* { NIkita:  
              {authenticated.role} <br />
              {isAnyPaidSlots}
              <br />
              {props.viewListDetails.tenderType}
              <br />
              {props.viewListDetails.lotTransferCount}-
              <br />
              {"isTranferButtonVisible : " +
                props.viewListDetails.isTranferButtonVisible}
              <br />
              {props.viewListDetails.status}
              <br />
              {props.viewTenderDetails.isSanctionLetterGenerated
                ? "isSanctionLetterGenerated : TRUE"
                : " isSanctionLetterGenerated : FALSE"}
              <br />
              {props.viewListDetails.isSanctionAccepted
                ? "isSanctionAccepted : TRUE"
                : "isSanctionAccepted : FALSE"}
              <br />
              {props.viewTenderDetails.isAgreementLetterGenerated
                ? "isAgreementLetterGenerated :TRUE"
                : "isAgreementLetterGenerated: FALSE"}
              <br />
              {props.viewListDetails.isAgreementAccepted
                ? "isAgreementAccepted: TRUE"
                : "isAgreementAccepted:FALSE"}
              <br />
              {props.viewListDetails.isCCFSignedAgreement
                ? "isCCFSignedAgreement : TRUE"
                : " isCCFSignedAgreement : FALSE"}{" "}
              <br />
              {props.viewListDetails.isTransferFees_EMD_Visible
                ? "isTransferFees_EMD_Visible: TRUE"
                : "isTransferFees_EMD_Visible :FALSE"}{" "}
              <br />
              {props.viewTransferDetails.length > 0
                ? "props.viewTransferDetails : true"
                : "props.viewTransferDetails : false"}
              <br />*/}
      {authenticated.role === "Bidder" &&
        props.isAnyPaidSlots === 0 &&
        props.viewListDetails.tenderType === 1 &&
        props.viewListDetails.actualQuantity !== 0 &&
        props.viewListDetails.lotTransferCount < 2 &&
        props.viewListDetails.isTranferButtonVisible &&
        props.viewListDetails.status !== "Terminated" &&
        props.viewTenderDetails?.isSanctionLetterGenerated &&
        props.viewListDetails.isSanctionAccepted === 1 &&
        props.viewTenderDetails?.isAgreementLetterGenerated &&
        props.viewListDetails.isAgreementAccepted === 1 &&
        props.viewListDetails.isCCFSignedAgreement === true &&
        props.viewTransferDetails &&
        !props.viewListDetails.isRequiredToReturnAdjustmentAmt &&
        (props.viewTransferDetails.length === 0 ||
          props.viewTransferDetails[props.viewTransferDetails.length - 1]
            .status !== 0) && (
          <div className="row">
            <div className="col-xl-12">
              <CButton
                className="ml-2 mr-2"
                color="info"
                disabled={props.viewListDetails.disableTransferButton}
                onClick={() => history.push(`/transferlot/${props.lotId}`)}
              >
                Transfer
              </CButton>
            </div>
          </div>
        )}
    </>
  );
};

export default LotListViewTransferButton;
